import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Forum as ForumIcon, Message as MessageIcon } from "@material-ui/icons";

const EmptyMessagesPlaceholder = ({ mobile }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      p={3}
    >
      {mobile ? (
        <MessageIcon style={{ fontSize: 64, color: "#ccc", marginBottom: 16 }} />
      ) : (
        <ForumIcon style={{ fontSize: 64, color: "#ccc", marginBottom: 16 }} />
      )}
      <Typography variant="h6" color="textSecondary" gutterBottom>
        Selecciona una conversación
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        {mobile
          ? 'Ve a la pestaña "Conversaciones" y elige una conversación para comenzar a chatear'
          : "Elige una conversación de la lista para comenzar a chatear, o crea una nueva conversación"}
      </Typography>
    </Box>
  );
};

export default EmptyMessagesPlaceholder;
